import React from "react";

const TermOfServices = () => {
  return <div>TermOfServices</div>;
};

export default TermOfServices;
